// extracted by mini-css-extract-plugin
export default {"footer":"FormFooter_footer__tJB91","column":"FormFooter_column__KZbEx"};